import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_zulu-landing-hub/artifacts/jbf0rehr_horizontal-black.png";

const Header = ({ onApplyClick }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <>
      <header
        data-testid="header"
        className={`fixed top-0 w-full z-50 transition-all duration-500 ${
          scrolled
            ? "backdrop-blur-xl bg-black/70 border-b border-white/10"
            : "bg-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 h-20 flex items-center justify-between">
          <a href="#hero" onClick={(e) => { e.preventDefault(); scrollToTop(); }}>
            <img
              src={LOGO_URL}
              alt="Zulunity"
              className="h-10 sm:h-12 w-auto"
              data-testid="header-logo"
            />
          </a>
          <nav className="hidden md:flex items-center gap-8">
            <a href="#promo" className="text-sm text-neutral-400 hover:text-white transition-colors tracking-wide">
              Promoción
            </a>
            <a href="#audiencia" className="text-sm text-neutral-400 hover:text-white transition-colors tracking-wide">
              Para quién
            </a>
            <a href="#por-que" className="text-sm text-neutral-400 hover:text-white transition-colors tracking-wide">
              Nosotros
            </a>
            <a href="#como-funciona" className="text-sm text-neutral-400 hover:text-white transition-colors tracking-wide">
              Proceso
            </a>
          </nav>
          <button
            data-testid="header-cta-btn"
            onClick={onApplyClick}
            className="bg-white text-black font-bold text-xs tracking-[0.15em] uppercase px-6 py-3 hover:bg-neutral-200 transition-all active:scale-95"
          >
            Aplicar ahora
          </button>
        </div>
      </header>

      {/* Back to top */}
      <button
        data-testid="back-to-top-btn"
        onClick={scrollToTop}
        className={`fixed bottom-8 right-8 z-50 p-3 bg-white/10 backdrop-blur-md border border-white/10 text-white hover:bg-white/20 transition-all duration-300 ${
          scrolled ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        <ArrowUp className="w-4 h-4" />
      </button>
    </>
  );
};

export default Header;
